import { defineMessages } from 'react-intl';

export default defineMessages({

  haveYouReceivedReimbursement: {
    id: 'fastCover.stepTravelDelay.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received reimbursement?',
  },

  missedConnection: {
    id: 'fastCover.stepTravelDelay.missedConnection',
    defaultMessage: 'Are you claiming for Missed Connection?',
  },

  travelDelay: {
    id: 'fastCover.stepTravelDelay.travelDelay',
    defaultMessage: 'Are you claiming for Travel Delay?',
  },

  reasonsForTripInterruption: {
    id: 'fastCover.stepTravelDelay.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  reasons1: {
    id: 'fastCover.stepTravelDelay.reasons1',
    defaultMessage: 'Death of an Immediate Family Member',
  },

  reasons2: {
    id: 'fastCover.stepTravelDelay.reasons2',
    defaultMessage: 'Your Unforeseen Sickness or Injury or, the Sickness or Injury of a Traveling Companion or Immediate Family Member',
  },

  reasons3: {
    id: 'fastCover.stepTravelDelay.reasons3',
    defaultMessage: 'Substantial destruction of your principal residence by fire or weather-related activity',
  },

  reasons4: {
    id: 'fastCover.stepTravelDelay.reasons4',
    defaultMessage: 'A Medically Necessary covered Emergency Medical Evacuation to return to Your Home Country or to the area from which You were initially evacuated for continued treatment, recuperation, and recovery',
  },

  reasons5: {
    id: 'fastCover.stepTravelDelay.reasons5',
    defaultMessage: 'Any other medical reason',
  },

  companyNameTravelInterruption: {
    id: 'fastCover.stepTravelDelay.companyNameTravelInterruption',
    defaultMessage: 'Company Name',
  },

  addressTravelInterruption: {
    id: 'fastCover.stepTravelDelay.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.stepTravelDelay.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.stepTravelDelay.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.stepTravelDelay.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.stepTravelDelay.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  phoneNumberTravelInterruption: {
    id: 'fastCover.stepTravelDelay.phoneNumberTravelInterruption',
    defaultMessage: 'Phone Number',
  },

  includedInPackage: {
    id: 'fastCover.stepTravelDelay.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  lossInformationPerPerson: {
    id: 'fastCover.stepTravelDelay.lossInformationPerPerson',
    defaultMessage: 'Loss Information (per person)',
  },

  lossInformation: {
    id: 'fastCover.stepTravelDelay.lossInformation',
    defaultMessage: 'Loss Information',
  },

  missedConnectionInformation: {
    id: 'fastCover.stepTravelDelay.missedConnectionInformation',
    defaultMessage: 'Missed Connection Information',
  },

  addLossInformation: {
    id: 'fastCover.stepTravelDelay.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  dateTripInterrupted: {
    id: 'fastCover.stepTravelDelay.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },

  lossInformationWithIdx: {
    id: 'fastCover.stepTravelDelay.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  reasonForInterruption: {
    id: 'fastCover.stepTravelDelay.reasonForInterruption',
    defaultMessage: 'Reason for interruption',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.stepTravelDelay.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.stepTravelDelay.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.stepTravelDelay.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateSicknessOrInjuryBegan: {
    id: 'fastCover.stepTravelDelay.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },

  dateEnded: {
    id: 'fastCover.stepTravelDelay.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.stepTravelDelay.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  periodOfHospitalization: {
    id: 'fastCover.stepTravelDelay.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable)',
  },

  companyNameLoss: {
    id: 'fastCover.stepTravelDelay.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruise/travel agent/etc.)',
  },

  amountPaidLoss: {
    id: 'fastCover.stepTravelDelay.amountPaidLoss',
    defaultMessage: 'Amount Paid',
  },

  amountOfLoss: {
    id: 'fastCover.stepTravelDelay.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.stepTravelDelay.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  fromWhom: {
    id: 'fastCover.stepTravelDelay.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  reasonsForDelay: {
    id: 'fastCover.stepTravelDelay.reasonsForDelay',
    defaultMessage: 'Reasons for Delay',
  },

  reasonsForMissedConnection: {
    id: 'fastCover.stepTravelDelay.reasonsForMissedConnection',
    defaultMessage: 'Reasons for Missed Connection',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.stepTravelDelay.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.stepTravelDelay.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident enroute to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.stepTravelDelay.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.stepTravelDelay.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateOfInitialPaymentDeposit: {
    id: 'fastCover.stepTravelDelay.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment deposit',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.stepTravelDelay.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.stepTravelDelay.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  scheduledDateOfDeparture: {
    id: 'fastCover.stepTravelDelay.scheduledDateOfDeparture',
    defaultMessage: 'Scheduled date of departure',
  },

  scheduledTimeOfDeparture: {
    id: 'fastCover.stepTravelDelay.scheduledTimeOfDeparture',
    defaultMessage: 'Scheduled time of departure',
  },

  actualDateOfDeparture: {
    id: 'fastCover.stepTravelDelay.actualDateOfDeparture',
    defaultMessage: 'Actual date of departure',
  },

  actualTimeOfDeparture: {
    id: 'fastCover.stepTravelDelay.actualTimeOfDeparture',
    defaultMessage: 'Actual time of departure',
  },

  scheduledDateOfArrival: {
    id: 'fastCover.stepTravelDelay.scheduledDateOfArrival',
    defaultMessage: 'Scheduled date of arrival',
  },

  scheduledTimeOfArrival: {
    id: 'fastCover.stepTravelDelay.scheduledTimeOfArrival',
    defaultMessage: 'Scheduled time of arrival',
  },

  actualDateOfArrival: {
    id: 'fastCover.stepTravelDelay.actualDateOfArrival',
    defaultMessage: 'Actual date of arrival',
  },

  actualTimeOfArrival: {
    id: 'fastCover.stepTravelDelay.actualTimeOfArrival',
    defaultMessage: 'Actual time of arrival',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.stepTravelDelay.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.stepTravelDelay.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.stepTravelDelay.delayInformation',
    defaultMessage: 'Travel Delay Information',
  },

  addDelayInformation: {
    id: 'fastCover.stepTravelDelay.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.stepTravelDelay.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },
  dateReimbursementReceived: {
    id: 'fastCover.stepTravelDelay.dateReimbursementReceived',
    defaultMessage: 'Date Reimbursement Received',
  },

  yes: {
    id: 'fastCover.stepTravelDelay.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepTravelDelay.no',
    defaultMessage: 'No',
  },
  fromDate: {
    id: 'fastCover.stepTravelDelay.fromDate',
    defaultMessage: 'From Date',
  },
  toDate: {
    id: 'fastCover.stepTravelDelay.toDate',
    defaultMessage: 'To Date',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.stepTravelDelay.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.stepTravelDelay.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.stepTravelDelay.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  areYouClaimingFor: {
    id: 'fastCover.stepTravelDelay.areYouClaimingFor',
    defaultMessage: 'Are you claiming for',
  },
  loss: {
    id: 'fastCover.stepTravelDelay.loss',
    defaultMessage: 'Loss',
  },
  theft: {
    id: 'fastCover.stepTravelDelay.theft',
    defaultMessage: 'Theft',
  },
  damage: {
    id: 'fastCover.stepTravelDelay.damage',
    defaultMessage: 'Damage',
  },
  delay: {
    id: 'fastCover.stepTravelDelay.delay',
    defaultMessage: 'Delay',
  },
  whoDidYouReportThisTo: {
    id: 'fastCover.stepTravelDelay.whoDidYouReportThisTo',
    defaultMessage: 'Who did you report this to?',
  },
  police: {
    id: 'fastCover.stepTravelDelay.police',
    defaultMessage: 'Police',
  },
  hotelManagement: {
    id: 'fastCover.stepTravelDelay.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  cruiseShip: {
    id: 'fastCover.stepTravelDelay.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },
  airline: {
    id: 'fastCover.stepTravelDelay.airline',
    defaultMessage: 'Airline',
  },
  tourGuide: {
    id: 'fastCover.stepTravelDelay.tourGuide',
    defaultMessage: 'Tour Guide',
  },
  other: {
    id: 'fastCover.stepTravelDelay.other',
    defaultMessage: 'Other',
  },
  notReported: {
    id: 'fastCover.stepTravelDelay.notReported',
    defaultMessage: 'Not Reported',
  },
  otherDescription: {
    id: 'fastCover.stepTravelDelay.otherDescription',
    defaultMessage: 'If other, please describe',
  },
  reportReferenceNumber: {
    id: 'fastCover.stepTravelDelay.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },
  descriptionOfItem: {
    id: 'fastCover.stepTravelDelay.descriptionOfItem',
    defaultMessage: 'Description of item',
  },
  datePurchased: {
    id: 'fastCover.stepTravelDelay.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.stepTravelDelay.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.stepTravelDelay.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  currency: {
    id: 'fastCover.stepTravelDelay.currency',
    defaultMessage: 'Currency',
  },
  amountClaimed: {
    id: 'fastCover.stepTravelDelay.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.stepTravelDelay.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.stepTravelDelay.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.stepTravelDelay.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  item: {
    id: 'fastCover.stepTravelDelay.item',
    defaultMessage: 'Item',
  },
  claimed: {
    id: 'fastCover.stepTravelDelay.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.stepTravelDelay.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepTravelDelay.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.stepTravelDelay.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.stepTravelDelay.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.stepTravelDelay.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.stepTravelDelay.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.stepTravelDelay.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.stepTravelDelay.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.stepTravelDelay.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.stepTravelDelay.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.stepTravelDelay.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.stepTravelDelay.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.stepTravelDelay.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.stepTravelDelay.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.stepTravelDelay.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.stepTravelDelay.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.stepTravelDelay.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.stepTravelDelay.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.stepTravelDelay.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  other1: {
    id: 'fastCover.stepTravelDelay.other1',
    defaultMessage: 'Proof of loss (i.e. police report, report to hotel, airline, transport provider)',
  },
  other2: {
    id: 'fastCover.stepTravelDelay.other2',
    defaultMessage: 'Proof of ownership/receipts/bank statements for each item',
  },
  other3: {
    id: 'fastCover.stepTravelDelay.other3',
    defaultMessage: 'Written confirmation of an IMEI block from your network provider',
  },
  other4: {
    id: 'fastCover.stepTravelDelay.other4',
    defaultMessage: 'A damage/repair report or quotation',
  },
  other5: {
    id: 'fastCover.stepTravelDelay.other5',
    defaultMessage: 'Written confirmation of luggage delay',
  },
  other6: {
    id: 'fastCover.stepTravelDelay.other6',
    defaultMessage: 'Receipts, bank statements and/or proof of payment for each expense being claimed',
  },
  itemWithIdx: {
    id: 'fastCover.stepTravelDelay.itemWithIdx',
    defaultMessage: 'Item {idx}',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.stepTravelDelay.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.stepTravelDelay.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },
  detailsRegardingYourTripDelay: {
    id: 'fastCover.stepTravelDelay.detailsRegardingYourTripDelay',
    defaultMessage: 'Details regarding your Trip Delay',
  },
  dateTripWasDelayedWithTravelSupplier: {
    id: 'fastCover.stepTravelDelay.dateTripWasDelayedWithTravelSupplier',
    defaultMessage: 'Date Trip was delayed with Travel Supplier',
  },
  dateOfExpenses: {
    id: 'fastCover.stepTravelDelay.dateOfExpenses',
    defaultMessage: 'Date Of Expenses',
  },
  areYouCancellingTheTripDueToMedicalReasons: {
    id: 'fastCover.medicalExpenseStep.areYouCancellingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you cancelling the trip due to medical reasons?',
  },
  insureds: {
    id: 'fastCover.stepTravelDelay.addInsured',
    defaultMessage: 'Name(s) and birth dates of all claimants:',
  },
  travelSupplier: {
    id: 'fastCover.stepTravelDelay.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },
  dateTripWasCancelledWithTravelSupplier: {
    id: 'fastCover.stepTravelDelay.dateTripWasCancelledWithTravelSupplier',
    defaultMessage: 'Date Trip was cancelled with Travel Supplier',
  },
  reasonForCancellation: {
    id: 'fastCover.stepTravelDelay.reasonForCancellation',
    defaultMessage: 'Reason For Cancellation',
  },
  tripCancellationForAnyReason: {
    id: 'fastCover.stepTravelDelay.tripCancellationForAnyReason',
    defaultMessage: 'Are you claiming Trip Cancellation for Any Reason?',
  },
  addInsured: {
    id: 'fastCover.stepTravelDelay.addInsured',
    defaultMessage: 'Add Insured',
  },
  birthDay: {
    id: 'fastCover.stepTravelDelay.birthDay',
    defaultMessage: 'Birth Day',
  },
  fullName: {
    id: 'fastCover.stepTravelDelay.fullName',
    defaultMessage: 'Full Name',
  },
  insuredInformationWithIdx: {
    id: 'fastCover.stepTravelDelay.insuredInformationWithIdx',
    defaultMessage: 'Insured Information {idx}',
  },
  areYouInterruptingTheTripDueToMedicalReasons: {
    id: 'fastCover.stepTravelDelay.areYouInterruptingTheTripDueToMedicalReasons',
    defaultMessage: 'Are you interrupting the trip due to medical reasons?',
  },
  didTheDelayOccurDuringDeparture: {
    id: 'fastCover.stepTravelDelay.didTheDelayOccurDuringDeparture',
    defaultMessage: 'Did the delay occur during departure?',
  },
  didTheDelayOccurDuringArrival: {
    id: 'fastCover.stepTravelDelay.didTheDelayOccurDuringArrival',
    defaultMessage: 'Did the delay occur during arrival?',
  },
  
  detailsRegardingYourMissedConnection: {
    id: 'fastCover.stepTravelDelay.detailsRegardingYourMissedConnection',
    defaultMessage: 'Details regarding your Missed Connection',
  },
  dateOfLoss:{
    id: 'fastCover.stepTravelDelay.delayItem.dateOfLoss',
    defaultMessage: 'Date of Loss',
  },
  expenseFor: {
    id: 'fastCover.stepTravelDelay.expenseFor',
    defaultMessage: 'Expense For',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepTravelDelay/messages.js